import React from 'react';
import logo from '../../assets/images/footer/footer-logo.png';
import CMXlogo from '../../assets/images/header/cmx-cinebistro.svg';
import anPlaystore from '../../assets/images/footer/andriod_playStore.svg';
import iosappstrore from '../../assets/images/footer/ios_appStore.svg';

class Footer extends React.Component {
  render() {
    return (
      <>
      <footer className="cmx-pagefooter">
            <section className="">
                <section className="ftcnr-contblk">
                    <aside className="ft-socialwrap">
                        <h6>Connect with us</h6>
                        <ul>
                            <li><a href="https://www.facebook.com/cmxcinemas/" target="_blank" className="ft-fb" title="Facebook">Facebook</a></li>
                            <li><a href="https://twitter.com/CMXCinemas" target="_blank" className="ft-twit" title="Twitter">Twitter</a></li>
                            <li><a href="https://www.instagram.com/cmxcinemas/" target="_blank" className="ft-insta" title="Instagram">Instagram</a></li>
                            <li><a href="https://www.tiktok.com/cmxcinemas/" target="_blank" className="ft-tiktok" title="Tiktok">Tiktok</a></li>
                        </ul>
                    </aside>
                    <aside className="ft-stpgwrap">
                        <ul>
                            <li><a href="https://www.cmxcinemas.com/about-cmx-cinemas" title="About CMX">About CMX</a></li>
                            <li><a href="https://www.indeed.com/cmp/Cmx-Cinemas/jobs?clearPrefilter=1#cmp-skip-header-desktop" title="Careers" target="_blank">Careers</a></li>
                            <li><a href="https://www.cmxcinemas.com/newsletter" title="NewsLetter">Newsletter</a></li>
                            <li><a href="https://www.cmxcinemas.com/contact" title="Contact Us">Contact Us</a></li>
                            <li><a href="https://www.cmxcinemas.com/refunds" title="Refunds">Refunds</a></li>
                            <li><a href="https://www.cmxcinemas.com/terms-and-conditions" title="Terms of Use">Terms of Use</a></li>
                            <li><a href="https://www.cmxcinemas.com/privacy-notice" title="Privacy Policy">Privacy Policy</a></li>
                            <li><a href="https://www.cmxcinemas.com/safety-policy" title="Safety Policy">Safety Policy</a></li>
                            <li><a href="https://cmx-assets-01.s3.us-east-2.amazonaws.com/webassets/mpaa_ratings-poster-qr.pdf" target="_blank" title="MPAA Ratings">MPAA Ratings</a></li>
                        </ul>
                    </aside>
                </section>
                <section className="ftlca-contblk">
                    <section className="col-lca">
                        <aside className="w33">&nbsp;</aside>
                        <aside className="w33 ft-cmx-logo">
                            <figure>
                              <a onClick={this.props.CMXCinemalogo} href="javascript:;" title='CMX CINEMAS | CINEBISTRO'><img src={CMXlogo} className="img-fluid" alt="CMX" /></a>
                            </figure>
                            <p>© {(new Date().getFullYear())} CMX Cinemas</p>
                        </aside>
                        <aside className="w33 ft-cmx-store">
                          <ul>
                              <li><a href="https://apps.apple.com/us/app/cmx-cinemas/id1556073550" className="app-store" title="App Store" target="_blank"><img src={iosappstrore} alt="App Store" className="img-fluid" /></a></li>
                              <li><a href="https://play.google.com/store/apps/details?id=com.influx.cinema.cmx" className="play-store" title="Google Play" target="_blank"><img src={anPlaystore} alt="Google Play" className="img-fluid" /></a></li>
                          </ul>
                        </aside>
                    </section>
                    <p className="web-by">Website by <a href="https://www.influxworldwide.com/cinemas/" target="_blank" title="Influx">Influx</a></p>
                </section>
            </section>
        </footer>

       {/* <footer>
         <section className="cmx-flex-footer">
           <section className="row">
             <section className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-start">
               <p>© 2022 CMX Cinemas</p>
             </section>
             <section className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center">
                 <figure>
                   <a href="javascript:;"><img src={logo} alt="CMX Passport" className="img-fluid" /></a>
                 </figure>
             </section>
             <section className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end">
               <p><a href='https://myinfinity.co/direct/' target="_blank" title='Powered by influx'>Powered by influx</a></p>
             </section>
           </section>
         </section>
       </footer> */}
       </>
    )
  }
}

export default Footer;